import { axiosAPI as axios } from 'utils';
import jwt_decode from 'jwt-decode';

import { withLoading, setAuthToken, dream } from 'utils';
import { getActiveMobileFamilyFriend } from 'utils/mobileFamilyFriends';
import { LOGIN, LOGOUT } from './types';
import isMobileAppRuntime from 'utils/isMobileAppRuntime';
import { isOnline } from 'mobile-modules/offline';

const filter = 'auth';

export const getLoginScreenByEmail = (email) => (dispatch) =>
  withLoading(dispatch, async () => {
    try {
      const response = await axios.get(
        `/api/auth/login-screen-by-email/${email}`
      );
      return response.data;
    } catch (err) {
      return (err.response && err.response.data) || { status: false };
    }
  });

export const login = (loginData) => (dispatch) =>
  withLoading(dispatch, async () => {
    try {
      const res = await axios.post('/api/auth/login', loginData);

      dispatch(setAuthFromToken(res.data.token));

      return { success: true };
    } catch (err) {
      return { success: false, data: err.response.data };
    }
  });

export const cleverLogin = (code, url) => (dispatch) =>
  withLoading(dispatch, async () => {
    try {
      const res = await axios.post('/api/auth/clever-login', { code, url });
      dispatch(setAuthFromToken(res.data.token));

      return { success: true };
    } catch (err) {
      return { success: false, data: err.response.data };
    }
  });

export const updateToken = (token) => (dispatch) => {
  withLoading(dispatch, async () => {
    // Always restore the locally stored learner immediately. Native mobile then
    // refreshes it from the server only when a connection exists.
    dispatch(setAuthFromToken(token));

    if (isMobileAppRuntime() && !isOnline()) return;

    try {
      const res = await axios.get('/api/auth/updateToken');
      dispatch(setAuthFromToken(res.data.token));
    } catch (err) {
      console.log(err);
      const status = Number(err?.response?.status || 0);
      const networkFailure = !status;
      if (isMobileAppRuntime() && networkFailure) return;
      dispatch(logout());
    }
  });
};

export const forgotPassword = (email) => (dispatch) =>
  withLoading(dispatch, async () => {
    try {
      const normalizedEmail = String(email || '').trim().toLowerCase();
      await axios.post('/api/users/forgot-password', { email: normalizedEmail });
      return { success: true };
    } catch (err) {
      return {
        success: false,
        data: (err.response && err.response.data) || {
          errors: { email: 'Password reset request failed' },
        },
      };
    }
  });

export const setAuthFromToken = (token, options = {}) => {
  try {
    // Set token to local storage
    localStorage.setItem('jwtToken', token);
    // Decode token to get user data
    const decoded = jwt_decode(token);
    const persistedLocalFriend = getActiveMobileFamilyFriend();
    const localTeam = Array.isArray(options.localTeam)
      ? options.localTeam.filter(Boolean)
      : (persistedLocalFriend ? [persistedLocalFriend._id] : []);
    if (localTeam.length) {
      decoded.team = localTeam;
      decoded.isFamily = true;
    }

    // Set token to Auth header
    setAuthToken(token);

    // If user not learner, it should have userRole object
    if (decoded.user && !dream.isObject(decoded.userRole)) {
      throw new Error('User Role should be an object');
    }

    return {
      filter,
      type: LOGIN,
      payload: decoded,
    };
  } catch (e) {
    console.log(e.message);
    localStorage.removeItem('jwtToken');
    return logout();
  }
};

export const logout = (familyTeam = true) => {
  // Standard mobile logout ends only the active learner/play session.
  // flcMobileFamilyAccountToken is intentionally retained so the mobile
  // landscape family-member Login Screen can be shown immediately.
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('flcMobileSkipSplashOnce');
  if (familyTeam === false) localStorage.setItem('familyTeam', 'false');

  // Remove active learner auth header; family-session requests send their own token.
  setAuthToken();

  return {
    type: LOGOUT,
  };
};
